import Vue from 'vue'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { vue } from '@/main.js'

/**
 * Retorna os dados por equipe
 *
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da Equipe
 *
 * @returns {Array}
 */
export async function getCadastrosPorEquipe(cod_ibge, nu_ine) {
  try {
    const { data } = await Vue.prototype.$api.get(
      `/app/v2/faltosos-vacinas-0-15-anos/${cod_ibge}/equipe/${nu_ine}`
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

/**
 * Retorna os dados por microárea
 *
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da Equipe
 * @param {string} microarea
 *
 * @returns {Array}
 */
export async function getCadastrosPorMicroArea(cod_ibge, nu_ine, micro_area) {
  try {
    const { data } = await Vue.prototype.$api.get(
      `/app/v2/faltosos-vacinas-0-15-anos/${cod_ibge}/equipe/${nu_ine}/microarea/${micro_area}`
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

/**
 * Formata o array de dados com as doses
 *
 * @param {*} cadastros
 * @returns {Array}
 */
export function formatarCadastrosComDoses(cadastros) {
  return cadastros.map((item, index) => {
    const vacinasPendentes = JSON.parse(item.vacinas_pendentes)
    const vacinas = {
      covid19: JSON.parse(item.covid19) ?? [],
      bcg: JSON.parse(item.bcg) ?? [],
      hepb: JSON.parse(item.hepb) ?? [],
      penta: JSON.parse(item.penta) ?? [],
      dtp: JSON.parse(item.dtp) ?? [],
      vip: JSON.parse(item.vip) ?? [],
      vpc10: JSON.parse(item.vpc10) ?? [],
      rota: JSON.parse(item.rota) ?? [],
      menc: JSON.parse(item.menc) ?? [],
      vfa: JSON.parse(item.vfa) ?? [], // febre amarela
      hepa_inf: JSON.parse(item.hepa_inf) ?? [],
      scr: JSON.parse(item.scr) ?? [],
      var: JSON.parse(item.var) ?? [],
      hpv: JSON.parse(item.hpv) ?? [],
      dt: JSON.parse(item.dt) ?? [], // dupla adulto
      men_acwy: JSON.parse(item.men_acwy) ?? [],
    }

    const vacinaConfig = [
      {
        nome: 'coresCovid19',
        vacina: 'covid19',
        id_mn: '99',
        doses: [
          { label: '1ª DOSE', id_ds: '1', idade: '6 meses' },
          { label: '2ª DOSE', id_ds: '2', idade: '7 meses' },
          { label: '3ª DOSE', id_ds: '3', idade: '9 meses' },
        ],
      },
      {
        nome: 'coresBcg',
        vacina: 'bcg',
        id_mn: '15',
        doses: [{ label: 'ÚNICA', id_ds: '9', idade: 'Ao nascer' }],
      },
      {
        nome: 'coresPenta',
        vacina: 'penta',
        id_mn: '42',
        doses: [
          { label: '1ª DOSE', id_ds: '1', idade: '2 meses' },
          { label: '2ª DOSE', id_ds: '2', idade: '4 meses' },
          { label: '3ª DOSE', id_ds: '3', idade: '6 meses' },
        ],
      },
      {
        nome: 'coresVip',
        vacina: 'vip',
        id_mn: '22',
        doses: [
          { label: '1ª DOSE', id_ds: '1', idade: '2 meses' },
          { label: '2ª DOSE', id_ds: '2', idade: '4 meses' },
          { label: '3ª DOSE', id_ds: '3', idade: '6 meses' },
          {
            label: '1º REFORÇO',
            id_ds: '6',
            id_ds_aplicada: ['6', '38'],
            idade: '15 meses',
          },
          { label: '2º REFORÇO', id_ds: '7', idade: '4 anos' },
        ],
      },
      {
        nome: 'coresDtp',
        vacina: 'dtp',
        id_mn: '46',
        doses: [
          { label: '1º REFORÇO', id_ds: '6', idade: '15 meses' },
          { label: '2º REFORÇO', id_ds: '7', idade: '4 anos' },
        ],
      },
      {
        nome: 'coresHepatiteB',
        vacina: 'hepb',
        id_mn: '9',
        doses: [
          { label: '1ª DOSE', id_ds: '1', idade: '' },
          { label: '2ª DOSE', id_ds: '2', idade: '' },
          { label: '3ª DOSE', id_ds: '3', idade: '' },
          { label: 'DOSE', id_ds: '8', idade: 'Ao nascer' },
        ],
      },
      {
        nome: 'coresPneumococica',
        vacina: 'vpc10',
        id_mn: '26',
        doses: [
          { label: '1ª DOSE', id_ds: '1', idade: '2 meses' },
          { label: '2ª DOSE', id_ds: '2', idade: '4 meses' },
          { label: 'REFORÇO', id_ds: '38', idade: '12 meses' },
          { label: 'ÚNICA', id_ds: '9', idade: '12 meses a 4 anos' },
        ],
      },
      {
        nome: 'coresRotaVirus',
        vacina: 'rota',
        id_mn: '45',
        doses: [
          { label: '1ª DOSE', id_ds: '1', idade: '2 meses' },
          { label: '2ª DOSE', id_ds: '2', idade: '4 meses' },
        ],
      },
      {
        nome: 'coresMeningococicaC',
        vacina: 'menc',
        id_mn: '41',
        doses: [
          { label: '1ª DOSE', id_ds: '1', idade: '3 meses' },
          { label: '2ª DOSE', id_ds: '2', idade: '5 meses' },
          { label: 'REFORÇO', id_ds: '38', idade: '12 meses' },
        ],
      },
      {
        nome: 'coresFebreAmarela',
        vacina: 'vfa',
        id_mn: '14',
        doses: [
          { label: 'DOSE', id_ds: '8', idade: '9 meses' },
          { label: 'REFORÇO', id_ds: '38', idade: '4 anos' },
          { label: 'ÚNICA', id_ds: '9', idade: '5 a 59 anos' },
        ],
      },
      {
        nome: 'coresHepatiteA',
        vacina: 'hepa_inf',
        id_mn: '55',
        doses: [{ label: 'ÚNICA', id_ds: '9', idade: '15 meses' }],
      },
      {
        nome: 'coresTripliceViral',
        vacina: 'scr',
        id_mn: '24',
        doses: [
          { label: '1ª DOSE', id_ds: '1', idade: '12 meses' },
          { label: '2ª DOSE', id_ds: '2', idade: '15 meses' },
          { label: 'DOSE', id_ds: '8', idade: '30 a 59 anos' },
        ],
      },
      {
        nome: 'coresTetraViral',
        vacina: 'scr',
        id_mn: '56',
        doses: [{ label: 'ÚNICA', id_ds: '9', idade: '15 meses' }],
      },
      {
        nome: 'coresVaricela',
        vacina: 'var',
        id_mn: '34',
        doses: [
          { label: '1ª DOSE', id_ds: '1', idade: '15 meses' },
          { label: '2ª DOSE', id_ds: '2', idade: '4 a 6 anos' },
          { label: 'ÚNICA', id_ds: '9', idade: '' },
        ],
      },
      {
        nome: 'coresHpv',
        vacina: 'hpv',
        id_mn: '67',
        doses: [{ label: 'ÚNICA', id_ds: '9', idade: '9 a 14 anos' }],
      },
      {
        nome: 'coresDuplaAdulto',
        vacina: 'dt',
        id_mn: '25',
        doses: [
          { label: '1ª DOSE', id_ds: '1', idade: '' },
          { label: '2ª DOSE', id_ds: '2', idade: '' },
          { label: '3ª DOSE', id_ds: '3', idade: '' },
          { label: 'REFORÇO', id_ds: '38', idade: '' },
        ],
      },
      {
        nome: 'coresAcwy',
        vacina: 'men_acwy',
        id_mn: '74',
        doses: [
          { label: 'DOSE', id_ds: '8', idade: '11 a 14 anos' },
          { label: 'REFORÇO', id_ds: '38', idade: '11 a 14 anos' },
        ],
      },
    ]

    const resultadoVacinas = vacinaConfig.reduce((acc, config) => {
      if (config.vacina === 'covid19') {
        acc[config.nome] = processarDosesCovid(
          vacinas[config.vacina],
          config.id_mn,
          config.doses,
          vacinasPendentes
        )
      } else if (config.vacina === 'hpv') {
        acc[config.nome] = processarDosesHpv(
          vacinas[config.vacina],
          config.id_mn,
          config.doses,
          vacinasPendentes
        )
      } else {
        acc[config.nome] = processarDoses(
          vacinas[config.vacina],
          config.id_mn,
          config.doses,
          vacinasPendentes
        )
      }
      return acc
    }, {})

    return {
      id: index,
      ...item,
      ...resultadoVacinas,
    }
  })
}

/**
 * Processa as doses configuradas da hpv
 * Exibe apenas uma dose, mas busca com prioridade:
 * ÚNICA (9) -> 2ª dose (2) -> 1ª dose (1)
 *
 * @param {Array} vacina Dados da vacina
 * @param {String|Number} id_mn Identificador do imunobiológico
 * @param {Array} dosesConfig Configuração das doses para exibição
 * @param {Array} vacinasPendentes Lista de vacinas pendentes
 * @returns {Array} Lista de doses processadas
 */
function processarDosesHpv(vacina, id_mn, dosesConfig, vacinasPendentes) {
  const configExibicao = dosesConfig[0]

  if (!configExibicao) {
    return []
  }

  const prioridades = ['9', '2', '1']

  let doseEncontrada = null

  for (const id_ds of prioridades) {
    const resultado = encontrarDose(vacina, id_mn, id_ds, vacinasPendentes)

    if (resultado.cor !== 'white') {
      doseEncontrada = resultado
      break
    }

    // guarda a última branca caso nenhuma seja encontrada
    if (!doseEncontrada) {
      doseEncontrada = resultado
    }
  }

  return [
    {
      dose: configExibicao.label,
      cor: doseEncontrada.cor,
      tag: doseEncontrada.tag || '',
      id_ds: configExibicao.id_ds || '',
      id_mn: id_mn || '',
      dt_plc:
        doseEncontrada.tipo === 'aplicada'
          ? doseEncontrada.dt_plc
          : configExibicao.idade,
      dt_plc_br:
        doseEncontrada.tipo === 'aplicada'
          ? doseEncontrada.dt_plc_br
          : configExibicao.idade,
      orig: doseEncontrada.orig || '',
      lt: doseEncontrada.lt || '',
    },
  ]
}

/**
 * Processa as doses configuradas de uma vacina.
 * Monta os cards com cor, data e ids para exibição/salvamento.
 * Aceita `id_ds_aplicada` na config para priorizar IDs na busca da dose aplicada
 * (ex.: VIP 1º reforço: ['6', '38']).
 *
 * @param {Array} vacina Lista de doses aplicadas da vacina
 * @param {String|Number} id_mn Identificador do imunobiológico
 * @param {Array} dosesConfig Configuração das doses (label, id_ds, idade, id_ds_aplicada?)
 * @param {Array} vacinasPendentes Lista de vacinas pendentes
 * @returns {Array} Lista de doses processadas
 */
function processarDoses(vacina, id_mn, dosesConfig, vacinasPendentes) {
  return dosesConfig.map(({ label, id_ds, idade, id_ds_aplicada }) => {
    const dose = encontrarDose(
      vacina,
      id_mn,
      id_ds,
      vacinasPendentes,
      id_ds_aplicada
    )

    return {
      dose: label,
      cor: dose.cor,
      tag: dose.tag || '',
      id_ds: dose.id_ds || '',
      id_mn: dose.id_mn || '',
      dt_plc: dose.tipo === 'aplicada' ? dose.dt_plc : idade,
      dt_plc_br: dose.tipo === 'aplicada' ? dose.dt_plc_br : idade,
      orig: dose.orig || '',
      lt: dose.lt || '',
    }
  })
}

/**
 * Processa as doses configuradas da covid.
 * @param {Object} vacina Dados da vacina
 * @param {String|Number} id_mn Identificador do imunobiológico
 * @param {Array} dosesConfig Configuração das doses
 * @param {Array} vacinasPendentes Lista de vacinas pendentes
 * @returns {Array} Lista de doses processadas
 */
function processarDosesCovid(vacina, id_mn, dosesConfig, vacinasPendentes) {
  const dosesArr = vacina || []
  const pendArr = vacinasPendentes || []

  return dosesConfig.map(({ label, id_ds, idade }) => {
    // todas as aplicações dessa dose (id_ds)
    const aplicadas = dosesArr
      .filter((el) => el.id_ds == id_ds)
      .map((ap) => ({
        ...ap,
        dt_plc_br: ap.dt_plc?.split('-').reverse().join('/') || '',
      }))

    // pega só a maior data (dt_plc é YYYY-MM-DD, então comparar string funciona)
    const aplicadaMax = aplicadas
      .filter((a) => a.dt_plc) // garante que tem data
      .sort((a, b) => String(b.dt_plc).localeCompare(String(a.dt_plc)))[0]

    // aplicada
    if (aplicadaMax) {
      const id_mn_list = [
        ...new Set(aplicadas.map((x) => x.id_mn).filter(Boolean)),
      ]

      return {
        dose: label,
        cor: 'green',
        tag: '',
        id_ds,
        id_mn,
        id_mn_list,
        aplicadas: [aplicadaMax],
        orig: aplicadaMax.orig || '',
        lt: aplicadaMax.lt || '',
        dt_plc: aplicadaMax.dt_plc,
      }
    }

    // pendente
    const pendente = pendArr.find(
      (el) => el.id_ds == id_ds && el.id_mn == id_mn && el.na == '0'
    )
    if (pendente) {
      return {
        dose: label,
        cor: 'red',
        tag: pendente.tag || '',
        id_ds,
        id_mn,
        dt_plc: idade,
        dt_plc_br: idade,
        aplicadas: [],
        orig: pendente.orig || '',
        lt: pendente.lt || '',
      }
    }

    // brancas
    return {
      dose: label,
      cor: 'white',
      tag: '',
      id_ds,
      id_mn,
      dt_plc: idade,
      dt_plc_br: idade,
      aplicadas: [],
      orig: '',
      lt: '',
    }
  })
}

/**
 * Localiza a dose aplicada ou pendente de uma vacina.
 * Ordem: aplicada (por prioridade de id_ds_aplicada ou id_ds) → pendente (id_ds) → branco.
 * Usado no VIP 1º reforço para buscar aplicada em '6' e, se não houver, em '38',
 * mantendo a pendência apenas em '6'.
 *
 * @param {Array} doses Lista de doses aplicadas
 * @param {String|Number} id_mn Identificador do imunobiológico
 * @param {String|Number} id_ds Identificador da dose (pendência e fallback da aplicada)
 * @param {Array} vacinasPendentes Lista de vacinas pendentes
 * @param {Array} [id_ds_aplicada] IDs alternativos para dose aplicada (ordem de prioridade)
 * @returns {Object} Dados da dose encontrada ou padrão (cor green/red/white)
 */
function encontrarDose(
  doses,
  id_mn,
  id_ds,
  vacinasPendentes,
  id_ds_aplicada = null
) {
  const idsAplicada = Array.isArray(id_ds_aplicada) && id_ds_aplicada.length
    ? id_ds_aplicada
    : [id_ds]

  for (const idAplicada of idsAplicada) {
    const aplicada = doses.find(
      (el) => el.id_ds == idAplicada && el.id_mn == id_mn
    )
    if (aplicada) {
      return {
        tipo: 'aplicada',
        cor: 'green',
        ...aplicada,
        dt_plc_br: aplicada.dt_plc?.split('-').reverse().join('/') || '',
      }
    }
  }

  const pendente = vacinasPendentes?.find(
    (el) => el.id_ds == id_ds && el.id_mn == id_mn && el.na == '0'
  )
  if (pendente) {
    // Se for hepatite b, fica branco
    let cor = id_mn == '9' ? 'white' : 'red'
    return {
      tipo: 'pendente',
      cor: cor,
      ...pendente,
      dt_plc_br: '',
    }
  }

  return {
    tipo: 'pendente',
    id_ds: id_ds,
    id_mn: id_mn,
    cor: 'white',
  }
}

/**
 * Formata as vacinas para exibir no PDF
 *
 * @param {*} doses
 * @param {*} label
 * @param {*} corAlvo
 * @returns {String}
 */
function formatarVacinasParaPdf(doses = [], label, corAlvo) {
  const filtradas = (doses || []).filter((obj) => obj.cor === corAlvo)
  if (filtradas.length === 0) return ''

  const formatarData = (o) =>
    o.dt_plc_br || (o.dt_plc ? o.dt_plc.split('-').reverse().join('/') : '')

  // Se tiver "aplicadas", é o caso covid (agrupado)
  const temAplicadas = filtradas.some((obj) => Array.isArray(obj.aplicadas))

  if (temAplicadas) {
    // Ex.: "COVID 19 (1ª DOSE: 18/10/2025 | 2ª DOSE: 19/11/2025); "
    const partes = filtradas.map((obj) => {
      const datas = (obj.aplicadas || [])
        .map(
          (a) =>
            a.dt_plc_br ||
            (a.dt_plc ? a.dt_plc.split('-').reverse().join('/') : '')
        )
        .filter(Boolean)

      if (datas.length === 0) return obj.dose
      return `${obj.dose}: ${datas.join(' | ')}`
    })

    return `${label} (${partes.join(', ')}); `
  }

  // Vacinas normais (mostrar dose + data quando tiver)
  // Ex.: "BCG (ÚNICA: 01/02/2025); " ou "VIP (1ª DOSE: 2 meses); "
  const partes = filtradas.map((obj) => {
    const data = formatarData(obj)
    return data ? `${obj.dose}: ${data}` : obj.dose
  })

  return `${label} (${partes.join(', ')}); `
}

const VACINAS_PDF = [
  { key: 'coresBcg', label: 'BCG' },
  { key: 'coresHepatiteB', label: 'HEPATITE B' },
  { key: 'coresPenta', label: 'PENTAVALENTE' },
  { key: 'coresDtp', label: 'DTP' },
  { key: 'coresVip', label: 'VIP' },
  { key: 'coresPneumococica', label: 'PNEUMOCÓCICA 10V (CONJUGADA)' },
  { key: 'coresRotaVirus', label: 'ROTAVÍRUS HUMANO' },
  { key: 'coresMeningococicaC', label: 'MENINGOCÓCICA C (CONJUGADA)' },
  { key: 'coresFebreAmarela', label: 'FEBRE AMARELA' },
  { key: 'coresHepatiteA', label: 'HEPATITE A' },
  { key: 'coresTripliceViral', label: 'TRÍPLICE VIRAL' },
  { key: 'coresTetraViral', label: 'TETRA VIRAL' },
  { key: 'coresVaricela', label: 'VARICELA' },
  { key: 'coresHpv', label: 'HPV' },
  { key: 'coresAcwy', label: 'ACWY' },
  { key: 'coresDuplaAdulto', label: 'DUPLA ADULTO' },
  { key: 'coresCovid19', label: 'COVID 19' },
]

function montarTextoVacinas(cadastro, cor) {
  return VACINAS_PDF.map(({ key, label }) =>
    formatarVacinasParaPdf(cadastro[key], label, cor)
  )
    .join('')
    .trim()
}

/**
 * Gera o relatório em PDF
 *
 * @param {Array} cadastros
 * @param {Object} selectEquipe
 * @param {Object} selectMicroarea
 * @param {Object} filtroIdade
 * @param {Object} filtroVacina
 */
export function generatePdf(
  cadastros,
  selectEquipe,
  selectMicroarea,
  filtroIdade,
  filtroVacina
) {
  let cadastrosPdf = formatarCadastrosComDoses(cadastros)
  let title_pdf = '0 - 15 anos'
  let titlePdfSave = utils.methods.titlePdf(
    '0 - 15 anos',
    selectEquipe.no_equipe
  )

  let description_pdf = 'Situação vacinal de crianças com menos de 0 a 15 anos'
  let headers_pdf = ['DADOS PESSOAIS', 'VACINAS PENDENTES', 'VACINAS APLICADAS']

  let data_pdf = []
  for (let i = 0; i < cadastrosPdf.length; i++) {
    const c = cadastrosPdf[i]

    let obj = {}

    obj.dados_pessoais = `Nome: ${
      c.no_cidadao
    }\nNascimento: ${utils.methods.formatDate(c.dt_nascimento)} ${
      c.idade_meses > 24
        ? `(${c.idade_anos} anos)`
        : `(${c.idade_meses} ${
            c.idade_meses == 0 || c.idade_meses == 1 ? 'mês' : 'meses'
          })`
    }\nMãe: ${c.no_mae}\nMA: ${c.micro_area ?? ''}\n`

    obj.vacinas_pendentes = montarTextoVacinas(c, 'red')
    obj.vacinas_aplicadas = montarTextoVacinas(c, 'green')
    data_pdf.push(obj)
  }
  let doc = new jsPDF('l', 'pt')
  // cria a tabela
  let table = utils.methods.createTablePdf(data_pdf)

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64data) => {
      // Header
      let verticalPosition = headerPdf(
        doc,
        base64data,
        title_pdf,
        description_pdf
      )
      // Equipe
      if (selectEquipe !== '') {
        doc.setFontSize(12)
        doc.text(
          'Equipe: ' + selectEquipe.no_equipe,
          40,
          verticalPosition,
          null,
          null,
          'left'
        )
        verticalPosition += 16
        doc.text(
          'INE: ' + selectEquipe.ine_esf_eap,
          40,
          verticalPosition,
          null,
          null,
          'left'
        )
      }
      // Microárea
      if (selectMicroarea != '') {
        verticalPosition += 16
        doc.setFontSize(12)
        doc.text(
          'Microárea: ' + selectMicroarea,
          40,
          verticalPosition,
          null,
          null,
          'left'
        )
      }
      // Filtro idade
      if (filtroIdade != null) {
        verticalPosition += 16
        doc.text(
          'Idade: ' + filtroIdade.label,
          40,
          verticalPosition,
          null,
          null,
          'left'
        )
      }
      // Filtro vacina
      if (filtroVacina != null) {
        verticalPosition += 16
        doc.text(
          'Vacina: ' + filtroVacina.label,
          40,
          verticalPosition,
          null,
          null,
          'left'
        )
      }

      // Data atual
      verticalPosition += 16
      let data = new Date()
      let dia = String(data.getDate()).padStart(2, '0')
      let mes = String(data.getMonth() + 1).padStart(2, '0')
      let ano = data.getFullYear()
      let dataAtual = dia + '/' + mes + '/' + ano
      doc.setFontSize(12)
      doc.text(`Data: ${dataAtual}`, 40, verticalPosition, null, null)

      verticalPosition += 16

      doc.autoTable({
        head: [headers_pdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        columnStyles: {
          0: { cellWidth: 220 },
        },
        bodyStyles: {
          halign: 'left',
          fontSize: 6,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
      })

      footerPdf(doc, doc.autoTable.previous.finalY)

      doc.save(titlePdfSave + '.pdf')

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}

/**
 * Monta o header do PDF
 *
 * @param {*} doc
 * @param {*} base64data
 * @param {*} title_pdf
 * @param {*} description_pdf
 * @returns {Number}
 */
function headerPdf(doc, base64data, title_pdf, description_pdf) {
  let verticalPosition = 30
  // Brasão
  const pageWidth = doc.internal.pageSize.getWidth()
  const marginXtext = pageWidth / 2
  const marginXimg = pageWidth / 2 - 20

  if (base64data != '') {
    doc.addImage(base64data, marginXimg, verticalPosition, 40, 40)
    verticalPosition += 55
  }

  doc.setFontSize(14)
  doc.text(
    store.state.cidade,
    marginXtext,
    verticalPosition,
    null,
    null,
    'center'
  )
  verticalPosition += 20
  doc.text(
    'SECRETARIA MUNICIPAL DE SAÚDE',
    marginXtext,
    verticalPosition,
    null,
    null,
    'center'
  )
  // Linha
  verticalPosition += 10
  doc.line(
    10,
    verticalPosition,
    doc.internal.pageSize.getWidth() - 10,
    base64data != '' ? 110 : 55
  )
  verticalPosition += 20
  // Título
  doc.setFontSize(14)
  doc.text(title_pdf, marginXtext, verticalPosition, null, null, 'center')
  verticalPosition += 16
  // Descrição
  doc.setFontSize(12)
  doc.text(description_pdf, marginXtext, verticalPosition, null, null, 'center')
  verticalPosition += 24
  return verticalPosition
}

/**
 * Monta o footer do PDF
 * @param {*} doc
 * @param {*} verticalPosition
 * @param {*} x1Line
 * @param {*} widthLine
 */
function footerPdf(doc, verticalPosition, x1Line = 250, widthLine = 600) {
  const pageWidth = doc.internal.pageSize.getWidth()
  const marginXtext = pageWidth / 2
  let position = verticalPosition

  // Data atual
  let data = new Date()
  let dia = String(data.getDate()).padStart(2, '0')
  let mes = String(data.getMonth() + 1).padStart(2, '0')
  let ano = data.getFullYear()
  let dataAtual = dia + '/' + mes + '/' + ano

  doc.setFontSize(12)
  doc.text(
    `${store.state.cidade}, ${dataAtual}.`,
    40,
    (position += 40),
    null,
    null
  )
  // Linha
  doc.line(x1Line, (position += 50), widthLine, position)
  // Responsável
  doc.setFontSize(14)
  doc.text('Responsável', marginXtext, (position += 16), null, null, 'center')
}

export const dataFields = {
  Nome: 'no_cidadao',
  Nascimento: {
    field: 'dt_nascimento',
    callback: (value) => {
      return value !== null ? utils.methods.formatDate(value) : ''
    },
  },
  Mãe: 'no_mae',
  MA: 'micro_area',
  doses_pendentes: {
    callback: (item) => montarTextoVacinas(item, 'red'),
  },
  doses_aplicadas: {
    callback: (item) => montarTextoVacinas(item, 'green'),
  },
}
